import { AuthenticationMethodType, AuthenticationReason } from '@mc-alberta/types';
import { AuthenticationStrategy } from './types/enums/AuthenticationStrategy';
/** The default, user-friendly base username for FIDO authenticators. */
export const DEFAULT_FIDO_NAME = 'Mastercard';
/**
 * List of strategies with their respective associated authentication method types.
 *
 * The order of this list dictates the execution order of strategies
 * (e.g., when FIDO2 is not applicable, the next strategy in line would be LVLR).
 */
export const STRATEGIES = [
    {
        strategy: AuthenticationStrategy.CONSUMER_OTP,
        types: [
            AuthenticationMethodType.SMS_OTP,
            AuthenticationMethodType.EMAIL_OTP
        ]
    },
    {
        strategy: AuthenticationStrategy.MDES,
        types: [
            // (APP_* not yet supported)
            // AuthenticationMethodType.APP_AUTHENTICATON,
            // AuthenticationMethodType.APP_OTP,
            AuthenticationMethodType.SMS_OTP,
            AuthenticationMethodType.EMAIL_OTP
        ]
    },
    {
        strategy: AuthenticationStrategy.FIDO2,
        types: [AuthenticationMethodType.FIDO2]
    },
    {
        strategy: AuthenticationStrategy.LVLR,
        types: [AuthenticationMethodType.LVLR]
    },
    {
        strategy: AuthenticationStrategy.THREE_DS,
        types: [AuthenticationMethodType.THREE_DS]
    },
    {
        strategy: AuthenticationStrategy.CSC_VALIDATION,
        types: [AuthenticationMethodType.CSC_VALIDATION]
    }
];
/**
 * Key-value pairs of strategy names to their respective EMVCo Verification Method codes.
 */
export const VERIFICATION_METHOD = {
    /** Unknown. */
    UNKNOWN: '00',
    /** ACS-based 3D-Secure verification. */
    THREE_DS: '01',
    /** Card security code validation. */
    CSC_VALIDATION: '02',
    /** MDES ID&V performed by the Stark framework. */
    MDES_OTP: '04',
    /**
     * A no-op vehicle for providing token information.
     * No authentication will occur with this method.
     */
    VEHICLE: '05',
    /** FIDO2 or biometrics. */
    FIDO2: '07',
    /** Prior ID&V occurred performed outside of the Stark framework. */
    IDV_EXTERNAL: '23',
    /** Low-value, low-risk authentication. */
    LVLR: '24',
    /** Risk-based MDES authentication. */
    MDES_RISK: '26'
};
/**
 * EMVCo Verification Result codes.
 */
export const VERIFICATION_RESULT = {
    /** Authentication successful. */
    VERIFIED: '01',
    /** Authentication attempted but failed. */
    NOT_VERIFIED: '02',
    /** No authentication attempted. */
    NOT_PERFORMED: '03'
};
/**
 * Mapping of authentication reasons to the respective priorities.
 */
export const AUTH_REASON_PRIORITY = {
    [AuthenticationReason.TRANSACTION_AUTHENTICATION]: 0,
    [AuthenticationReason.ENROL_FINANCIAL_INSTRUMENT]: 1,
    [AuthenticationReason.CONSUMER_IDENTITY_VALIDATION]: 2,
    [AuthenticationReason.CARD_VERIFICATION]: 3,
    [AuthenticationReason.AUTHENTICATOR_REGISTRATION]: 4
};
/**
 * Types of kpi resource
 */
export const KPI_RESOURCE = {
    CONSUMER: 'CONSUMER',
    CARD: 'CARD'
};
